import {NavLink} from "react-router-dom";

const Ad = () => {
return(
    <div className="container my-4">
    <NavLink to='https://new.grabone.co.nz/%3Cregion%3E/c/12th-birthday'>
        <img src="https://mediacdn.grabone.co.nz/asset/hQaO4t3rGh" alt="" style={{width:'100%'}}/>
    </NavLink>
    </div>
        
    )
}

export default Ad;